export { default } from './MainTitle';
